import { Home as HomeTemplate } from "components/templates";
import { ReactHelmetWithProvider } from "providers/ReactHelmetProvider";

const Home = () => (
  <div className="home-page">
    <ReactHelmetWithProvider>
      <meta name="description"
        content="Discover GCX gift cards at discounted prices. Buy, sell, or trade instantly in our secure gift card marketplace and save on top brands you love."
      />
      <title>Discounted Gift Cards Marketplace - Save Online Today | GCX</title>
      <link rel="canonical" href={process.env.REACT_APP_URL} />
    </ReactHelmetWithProvider>
    <HomeTemplate />
  </div>
);

export default Home;
